import SetLoadingContext from "contexts/SetLoadingContext";
import useDefinedContext from "./useDefinedContext";

function useSetLoading() {
  return useDefinedContext(SetLoadingContext);
}
export default useSetLoading;
